// extracted by mini-css-extract-plugin
export default {"Loadingpage":"Loadingpage_Loadingpage__MX10-","logo":"Loadingpage_logo__YfakM"};